import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function BackflowPreventerIcon(props) {
	return (
		<IconBase type="backflow-preventer" {...props}>
			<path d="M20.2678 6.20711L19.2071 7.26777L18.5 6.56066L19.5607 5.5L20.2678 6.20711Z" />
			<path d="M19.5355 9.74265L20.2426 9.03554L17.4142 6.20712L16.7071 6.91422L19.5355 9.74265Z" />
			<path d="M6.5 7C6.5 6.72386 6.72386 6.5 7 6.5C7.27614 6.5 7.5 6.72386 7.5 7H9.5C9.77614 7 10 7.22386 10 7.5C10 7.77614 9.77614 8 9.5 8H8L7.5 8.5V9.5L8 10H8.5C8.77614 10 9 10.2239 9 10.5H5C5 10.2239 5.22386 10 5.5 10H6L6.5 9.5V8.5L6 8H4.5C4.22386 8 4 7.77614 4 7.5C4 7.22386 4.22386 7 4.5 7H6.5Z" />
			<path d="M4 11V17H10V11H4Z" />
			<path d="M2 10H3.5V18H2V10Z" />
			<path d="M20 11L17 8L14 11L20 17V11Z" />
			<path d="M19.1464 17L14 11.8536V13.4853L14.0147 13.5H14V17H19.1464Z" />
			<path d="M13.5 10H10.5V18H13.5V10Z" />
			<path d="M20.5 18H22V10H20.5V18Z" />
		</IconBase>
	);
}
BackflowPreventerIcon.propTypes = iconPropTypes;
